import { ToastContainer } from 'react-toastify';

import CloseIcon from '~/shared/assets/icons/cancel.svg';

import 'react-toastify/dist/ReactToastify.css';

export default function Toaster() {
  return (
    <ToastContainer
      toastClassName="h-[99px] rounded-[12px]"
      bodyClassName="p-0"
      className="p-0 [&>div]:mb-0 max-w-[868px] w-full [&>div]:p-0"
      position="top-center"
      closeButton={({ closeToast }) => (
        <button className="w-fit h-fit mr-[12px] mt-[12px]" onClick={closeToast}>
          <CloseIcon className="w-[45px] h-[45px] stroke-grey cursor-pointer" />
        </button>
      )}
      hideProgressBar
      autoClose={5000}
      limit={5}
      stacked
    />
  );
}
